import {request, history} from '@umijs/max';
import dayjs from "dayjs";
import {isMicroApp} from '@/qiankun/env';
import {notifyTokenExpired} from '@/qiankun';
import {getAccessToken} from '@/util/Token';

export function getAuthHeader() {
    return {
        Token: getAccessToken().token || getAccessToken().accessToken || '',
        platform: 'new',
    };
}

export function getCurrentUser() {
    const accessToken = getAccessToken();
    if (accessToken) return accessToken;
    // 微应用没有accessToken，则清空本地存储并跳转登录
    if (isMicroApp()) return {};

    localStorage.clear();
    history.push('/login');
    return {};
}


export async function download(url: string, params: any, filename: string) {
    const response = await request<any>(url, {
        headers: getAuthHeader(),
        method: 'GET',
        params,
        responseType: 'blob',
    });
    const a = document.createElement('a');
    a.href = window.URL.createObjectURL(response);
    a.download = `${filename}-${dayjs().format('YYYYMMDDHHmmss')}.xlsx`;
    a.click();
    window.URL.revokeObjectURL(response);
}

export function getImageUploadUrlAndName(filePath: string, filename?: string) {
    return `${BASE_URL}/api/upload?filepath=${filePath}&filename=${filename}`;
}

export function getImageUploadUrl(filePath: string) {
    const filename = '';
    return `${BASE_URL}/api/upload?filepath=${filePath}&filename=${filename}`;
}

export function getImageUploadUrlToLocal() {
    return `${BASE_URL}/api/upload/local`;
}

export function getUploadUrl(relativePath: string) {
    return `${BASE_URL}/api/${
        relativePath.startsWith('/') ? relativePath.replace('/', '') : relativePath
    }`;
}

export function getEditorUploadUrl() {
    const konsoleToken = localStorage.getItem('konsole-token');
    if (konsoleToken) {
        const token = JSON.parse(konsoleToken);
        return `${BASE_URL}/api/upload/editor?accessToken=${token.accessToken}`;
    }
    return undefined;
}

export function logout() {
    if (isMicroApp()) {
        notifyTokenExpired();
        return;
    }
    localStorage.clear();
    window.open(`${AUTH_URL}`, '_self');
}
